import qz from 'qz-tray';

const CASH_DRAWER_KICK = '\x1B\x70\x00\x19\xFA';
const OPERATION_TIMEOUT_MS = 8000;

const withTimeout = <T,>(operation: Promise<T>, deadline: number, step: string): Promise<T> =>
  new Promise((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      const error = new Error(`QZ Tray không phản hồi khi ${step} sau ${OPERATION_TIMEOUT_MS / 1000} giây`);
      error.name = 'QzTrayTimeoutError';
      reject(error);
    }, Math.max(0, deadline - Date.now()));

    operation.then(resolve, reject).finally(() => window.clearTimeout(timeoutId));
  });

const qzTrayService = {
  openCashDrawer: async (): Promise<void> => {
    const deadline = Date.now() + OPERATION_TIMEOUT_MS;

    try {
      if (!qz.websocket.isActive()) {
        await withTimeout(qz.websocket.connect(), deadline, 'kết nối');
      }

      const printer = await withTimeout(qz.printers.getDefault(), deadline, 'tìm máy in');
      if (!printer) {
        throw new Error('Chưa cấu hình máy in mặc định để mở két');
      }

      await withTimeout(
        qz.print(qz.configs.create(printer), [
          {
            type: 'raw',
            format: 'command',
            data: CASH_DRAWER_KICK,
          },
        ]),
        deadline,
        'gửi lệnh mở két'
      );
    } catch (error) {
      if (error instanceof Error && error.name === 'QzTrayTimeoutError') {
        void qz.websocket.disconnect().catch((disconnectError: unknown) => {
          console.warn('Không thể ngắt kết nối QZ Tray sau khi hết thời gian chờ:', disconnectError);
        });
      }
      throw error;
    }
  },
};

export default qzTrayService;
